<div
  *transloco="let t; read: 'calculator_result.result.values.yearly-savings'"
  class="flex flex-col font-bold">
  <psc-section-title
    class="mb-2"
    [title]="t('title')"
    alignment="left"
    size="normal"
    [lineWidthPercentage]="100"
    [lineThickness]="2"></psc-section-title>

  <div class="grid grid-cols-4">
    <div></div>
    <div></div>
    <div class="text-color-blue1 text-right">{{t('before-solar')}}</div>
    <div class="text-color-sun-yellow text-right">{{t('after-solar')}}</div>
  </div>
  <!--   t(consumption-kwh.title, consumption-kwh.info, consumption-money.title, consumption-money.info, co2-reduction.title, co2-reduction.info, bill-reduction.title, bill-reduction.info) -->
  <psc-value-text
    *ngFor="let value of yearlySavingsValues; let even = even"
    [coloredRow]="even"
    [label]="t(value.labelKey + '.title')"
    [value]="value.value"
    [secondValue]="value.secondValue || '-'"
    [unit]="value.unit"
    [infoText]="t(value.labelKey + '.info')"
  ></psc-value-text>

  <div
    class="flex flex-col"
    [ngClass]="{'relative': extendedDataBlurred}"
    *ngIf="extendedData">
    <div
      *ngIf="extendedDataBlurred"
      class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  z-20 blur-none pointer-events-auto">
      <psc-pay-for-full
        [analysisId]="powerPlant?.analysisId"
        [userId]="powerPlant?.userId"></psc-pay-for-full>
    </div>
    <!--   t(annual-production-kwh.title, annual-production-kwh.info, feed-in-kwh.title, feed-in-kwh.info, saving-kwh.title, saving-kwh.info) -->
    <!--  t(annual-bill.title, annual-bill.info, overload-bill.title, overload-bill.info, feed-in-percentage.title, feed-in-percentage.info)  -->
    <!--  t(peak-power-money.title, peak-power-money.info, peak-power-percentage-reduction.title, peak-power-percentage-reduction.info)  -->
    <!--  t(annual-peak-power-saving-money.title, annual-peak-power-saving-money.info)  -->
    <psc-value-text
      *ngFor="let value of yearlySavingsAdvancedValues; let even = even"
      [ngClass]="{'blur-sm pointer-events-none': extendedDataBlurred}"
      [coloredRow]="even"
      [label]="t(value.labelKey + '.title')"
      [value]="value.value"
      [secondValue]="value.secondValue || '-'"
      [unit]="value.unit"
      [infoText]="t(value.labelKey + '.info')"
    ></psc-value-text>
  </div>
</div>
